'use strict';

(function() {
	angular.module('onboarding.services')
		.factory('authenticationService', authenticationService);


	var subjectObserverMessagesService, observerService, subjectMessages;

	authenticationService
		.$inject = ['$rootScope', '$http', '$log', 'subjectObserverMessagesService', 'observerService', '$window'];

	function authenticationService($rootScope, $http, $log, _subjectObserverMessagesService_, _observerService_, $window) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		subjectMessages = subjectObserverMessagesService.getSubjectMessages();

		return {
			isAuthorized: isAuthorized,
			isAuthorizedBrokerRead: isAuthorizedBrokerRead,
			logout: logout,
			getUserInfo: getUserInfo,
			getApplicationLinks: getApplicationLinks,
			changePassword: changePassword,
			getUserId: getUserId,
			validateCarrierEmail: validateCarrierEmail,
			resetPasswordByEmail: resetPasswordByEmail,
			resetPassword: resetPassword,
			isAuthenticated: isAuthenticated,
			getLogoutUrl: getLogoutUrl
		};


		function logout() {
			var baseUrl = $window.location.origin + '/',
				logoutUrl = 'logout';
			$rootScope.sessionService.destroy();
			$window.location.replace(baseUrl + logoutUrl);
		}

		function getLogoutUrl() {
			return $window.location.origin + '/' + 'logout';
		}

		function getUserInfo(scope) {
			return $http
				.get('/api/authentication/getuserinfo')
				.then(function(res) {
					$rootScope.sessionService.create(res.data);

					return res;
				})
				.catch(function(e) {
					observerService
						.sendMessageToSubject(scope, subjectMessages.COB_OBSERVER_LOGIN_FINISHED_FAIL, e.data);
					if (e.status === 403) {
						logout();
					}
				});
		}

		function getApplicationLinks() {
			return $http.get('/api/authentication/applicationlinks');
		}

		function changePassword(password) {
			var request = {
				Password: password
			};

			return $http.put('/api/brokersettings/password', request);
		}

		function validateCarrierEmail(emailAddress) {
			return $http.get('/api/authentication/validateCarrierEmail', { params: { emailAddress: emailAddress } });
		}

		function getUserId(emailAddress, countryCode, postalCode) {
			return $http.get('/api/authentication/getUserId',
				{ params: { emailAddress: emailAddress, countryCode: countryCode, postalCode: postalCode } });
		}

		function resetPasswordByEmail(userName) {
			return $http.get('/api/authentication/resetPasswordByEmail',
				{ params: { userName: userName } });
		}

		function resetPassword(password, encodedKey) {
			return $http.put('/api/authentication/resetPassword',
				{ password: password, encodedKey: encodedKey });
		}

		function isAuthorized(capability) {
			return (authenticationService.isAuthenticated() &&
            $rootScope.sessionService.getCapabilities().indexOf(capability) !== -1);
		}

		function isAuthenticated() {
			return $rootScope.sessionService.getUserName() !== null;
		}

		function isAuthorizedBrokerRead() {
			return $rootScope.sessionService.isAuthorizedBrokerRead();
		}

	}
})();
